<script>
  import { 
    FormGroup,
    CustomInput,
    Button,
    Modal, 
    ModalBody, 
    ModalFooter, 
    ModalHeader 
  } from 'sveltestrap';
  import { user,
    residents,
    minResidentsSelected } from '../store.js';
  import { form } from '../validate.js';
  import { AppController } from '../AppController.js';
  import { 
    toast,
    stickyToast,
    clearToasts } from '../components/Toast.svelte';
  import { showLoading } from '../components/Overlay.svelte';
  import TestAlertModal from '../components/TestAlertModal.svelte';

  let emailChecked = false;
  let smsChecked = false;
  let voiceChecked = true;
  let tabSelected = 'email';

  let alertInfo = {
    email_subject: '',
    email_body: '',
    file_attach: null,
    sms_body: '',
    voice_message: '',
    department: null,
    voice_send_date:'',
    voice_send_time: '13:0',
    created_by: `${$user.first_name} ${$user.last_name}`,
    label: ''
  }

  let files = [];
  let attachmentURL;
  let isModalOpen = false;
  let alertModalHeader = "";
  let alertModalBody = "";

  const { validate, ...alertForm } = form(() => ({
    label: { value: alertInfo.label, validators: ["required", "min:1"]},
    email_subject: { value: alertInfo.email_subject, validators: ["required", "min:1"]},
    email_body: { value: alertInfo.email_body, validators: ["required", "min:1"]},
    sms_body: { value: alertInfo.sms_body, validators: ["required", "min:1"] },
    voice_message: { value: alertInfo.voice_message, validators: ["required", "min:1"] },
    voice_send_date: { value: alertInfo.voice_send_date, validators: ["date"]}
  }));

  $: {
    if (emailChecked && !smsChecked && !voiceChecked) tabSelected = 'email';
    if (emailChecked && smsChecked && !voiceChecked) tabSelected = 'email';
    if (emailChecked && voiceChecked && !smsChecked) tabSelected = 'email';
    if (smsChecked && !emailChecked && !voiceChecked) tabSelected = 'sms';
    if (smsChecked && voiceChecked && !emailChecked) tabSelected='sms';
    if (voiceChecked && !emailChecked && !smsChecked) tabSelected = 'voice';
    
  }

  const send = async () => {

    let emails = [];
    let smsNumbers = [];
    let voiceNumbers = [];
    let alertStatDetail = [];

    $residents
      .filter(resident => resident.selected)
      .forEach(resident => {
        const residentInfo = {
          account: resident.account | "",
          name: `${resident.first_name} ${resident.last_name}`,
          address: `${resident.house_number} ${resident.street} ${resident.city}`,
          email_1: resident.email_1 | '',
          email_2: resident.email_2 | '',
          phone_1: resident.phone_1 | '',
          cell_1: resident.cell_1 | '',
          cell_2: resident.cell_2 | '',
          home_phone: resident.home_phone | '',
          email_sent: false,
          text_sent: false,
          voice_sent: false,
          sent: new Date().toString()
        }
        if(emailChecked && resident.email_1) {
          emails.push(resident.email_1);
          residentInfo.email_sent = true;
        }
        if(emailChecked && resident.email_2) { 
          emails.push(resident.email_2);
          residentInfo.email_sent = true;
        }
        if(smsChecked && resident.cell_1) {
          smsNumbers.push(resident.cell_1);
          residentInfo.text_sent = true;
        }
        if(smsChecked && resident.cell_2) {
          smsNumbers.push(resident.cell_2);
          residentInfo.text_sent = true;
        }
        if(voiceChecked && resident.home_phone) {
          voiceNumbers.push(resident.home_phone);
          residentInfo.voice_sent = true;
        }
        alertStatDetail.push(residentInfo);
      });

    const alert = {
      email: {
        subject: alertInfo.email_subject,
        body: alertInfo.email_body,
        recipients: [...new Set(emails)],
        from: $user.alert_email,
        fromName: `${$user.first_name} ${$user.last_name}`,
        replyTo: $user.email,
        files: files
      },
      sms: {
        message: alertInfo.sms_body,
        recipients: [...new Set(smsNumbers)],
        label: alertInfo.label
      },
      voice: {
        message: alertInfo.voice_message,
        from: $user.alert_phone,
        recipients: [...new Set(voiceNumbers)],
        voice_send_date: alertInfo.voice_send_date,
        voice_send_time: alertInfo.voice_send_time,
        voice_sound: $user.alert_voice,
        label: alertInfo.label
      },
      alertStatDetail
    };

    try {
      showLoading(true);
      clearToasts();
      const alertStats = await AppController.sendAlert(alert);
      toast('success', 5000, 'Sent', 'Alert was successfully sent.');
      // resetAlertInfo();
      // showAlertModal('Alert Sent', 'Alert was successfully sent.');
    } catch (err) {
      console.log(err);
      stickyToast('danger', 'Error', 'An error occured sending alert.');
      // showAlertModal('Alert Error', 'An error occurred while sending alert. Please contact support if this error persists.');
    } finally {
      showLoading(false);
    }
  }

  const showAlertModal = (header, body) => {
    alertModalHeader = header;
    alertModalBody = body;
    isModalOpen = true;
  }

  const hideAlertModal = () => {
    alertModalHeader = "";
    alertModalBody = "";
    isModalOpen = false;
  }

  const resetAlertInfo = () => {
    alertInfo = {
      email_subject: '',
      email_body: '',
      file_attach: null,
      sms_body: '',
      voice_message: '',
      department: null,
      voice_send_date:'',
      voice_send_time: '13:0',
      created_by: `${$user.first_name} ${$user.last_name}`,
      label: ''
    }
  }

  const showTestAlertModal = () => {
    AppController.displayTestAlertModal(true);
  }

  const sendTestVoiceAlert = async (phone) => {
    const alert = {
      email: {
        subject: alertInfo.email_subject,
        body: alertInfo.email_body,
        recipients: [],
        from: $user.alert_email,
        fromName: `${$user.first_name} ${$user.last_name}`,
        files: files
      },
      sms: {
        message: alertInfo.sms_body,
        recipients: []
      },
      voice: {
        message: alertInfo.voice_message,
        from: $user.alert_phone,
        recipients: [phone],
        voice_send_date: '',
        voice_send_time: undefined,
        voice_sound: $user.alert_voice,
        label: alertInfo.label
      }
    };

    try {
      showLoading(true);
      AppController.sendAlert(alert, true);
      toast('success', 5000, 'Sent', 'Test voice alert was successfully sent.');
    } catch (err) {
      stickyToast('danger', 'Error', 'An error occured sending test alert.');
    } finally {
      showLoading(false);
    }
  };

  const uploadFiles = async () => {
    clearToasts();
    try {
      showLoading(true);
      const uploadUrl = await AppController.uploadFiles(files[0], $user.account_id);
      attachmentURL = uploadUrl;
      // aligned below so it displays without extra space in body text area
      alertInfo.email_body = `
${alertInfo.email_body}
${attachmentURL}`;
    } catch (err) {
      console.log(err)
      stickyToast('danger', 'Error', 'File attachment upload failed');
    } finally {
      showLoading(false);
    }
  }

  $: isFormValid = 
    $alertForm.label.valid &&
    (
      emailChecked || smsChecked || voiceChecked
    ) &&
    (
      (emailChecked && $alertForm.email_subject.valid && $alertForm.email_body.valid) ||
      !emailChecked
    ) &&
    (
      (smsChecked && $alertForm.sms_body.valid) ||
      !smsChecked
    ) &&
    (
      (voiceChecked && $alertForm.voice_message.valid) ||
      !voiceChecked
    ) &&
    $minResidentsSelected;
</script>
<div class="row mt-3">
  <div class="col-md-12 stretch-card">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">
          Send Alert By
          {#if !emailChecked && !smsChecked && !voiceChecked}
            <span class='text-danger required-field no-text-transform'>(Select at least one delivery option)</span>
          {/if}
        </h4>
        <FormGroup>
          <div>
            <CustomInput
              type="switch"
              id="voiceSwitch"
              bind:checked={voiceChecked}
              label="Voice"
            />
            <CustomInput
              type="switch"
              id="smsSwitch"
              bind:checked={smsChecked}
              name="smsSwitch"
              label="Text" />
            <CustomInput
              type="switch"
              id="emailSwitch"
              name="emailSwitch"
              bind:checked={emailChecked}
              label="Email" />
          </div>
        </FormGroup>

        <div class='row'>
          <div class='col-md-12'>
            <div class="form-group">
              <label for="input-alert-label" class='required-field'>Alert Label</label>
              <input 
                type="text" 
                bind:value={alertInfo.label} 
                use:validate={alertInfo.label}
                class="form-control" 
                class:border-danger={!$alertForm.label.valid && $alertForm.label.dirty}
                id="input-alert-label" 
                placeholder="User label for alert broadcast">
              {#if $alertForm.label.errors.includes('required') && $alertForm.label.dirty}
                <p class='text-danger text-small'>Alert Label is required</p>
              {/if}
            </div>
          </div>
        </div>

        <ul class="nav nav-tabs" id="myTab" role="tablist">
          {#if voiceChecked}
            <li class="nav-item">
              <span class="nav-link" class:active="{tabSelected === 'voice'}" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="voice"
                aria-selected={tabSelected === 'voice'}>Voice</span>
            </li>
          {/if}
          {#if smsChecked}
            <li class="nav-item">
              <span class="nav-link" class:active="{tabSelected === 'sms'}" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="sms"
                aria-selected={tabSelected === 'sms'}>Text</span>
            </li>
          {/if}
          {#if emailChecked}
            <li class="nav-item">
              <span class="nav-link" class:active="{tabSelected === 'email'}" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="email"
                aria-selected={tabSelected === 'email'}>Email</span>
            </li>
          {/if}
        </ul>

        <div class="tab-content border-light" id="myTabContent">
          {#if voiceChecked}
            <div class="tab-pane fade" class:active="{tabSelected === 'voice'}" class:show="{tabSelected === 'voice'}" id="contact" role="tabpanel" aria-labelledby="voice-tab">
              <div class='row'>
                <div class='col-md-12'>
                  <div class="form-group">
                    <label for="input-voice-message" class='required-field'>Voice Message</label>
                    <textarea 
                      bind:value={alertInfo.voice_message}
                      use:validate={alertInfo.voice_message}
                      class="form-control" 
                      class:border-danger={!$alertForm.voice_message.valid && $alertForm.voice_message.dirty}
                      id="input-voice-message" 
                      placeholder="Voice Message"
                      rows="4"></textarea>
                    {#if $alertForm.voice_message.errors.includes('required') && $alertForm.voice_message.dirty}
                      <p class='text-danger text-small'>Voice message is required</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-12'>
                  <div class="form-group">
                    <label for="sendDate">Schedule Broadcast Date (leave blank to send now)</label>
                    <input 
                      bind:value={alertInfo.voice_send_date}
                      type="date" 
                      class="form-control" 
                      class:border-danger={!$alertForm.voice_send_date.valid }
                      id="sendDate" 
                      placeholder="MM/DD/YYYY">
                      {#if $alertForm.voice_send_date.errors.includes('date') }
                      <p class='text-danger text-small'>Date must be in MM/DD/YYYY format and not in the past</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-12'>
                  <div class="form-group">
                    <label for="sendTime">Schedule Broadcast Time</label>
                    <select 
                      bind:value={alertInfo.voice_send_time}
                      class="form-control" 
                      id="sendTime">
                      <option value='0:0'>12:00 am</option>
                      <option value='0:30'>12:30 am</option>
                      <option value='1:0'>1:00 am</option>
                      <option value='1:30'>1:30 am</option>
                      <option value='2:0'>2:00 am</option>
                      <option value='2:30'>2:30 am</option>
                      <option value='3:0'>3:00 am</option>
                      <option value='3:30'>3:30 am</option>
                      <option value='4:0'>4:00 am</option>
                      <option value='4:30'>4:30 am</option>
                      <option value='5:0'>5:00 am</option>
                      <option value='5:30'>5:30 am</option>
                      <option value='6:0'>6:00 am</option>
                      <option value='6:30'>6:30 am</option>
                      <option value='7:0'>7:00 am</option>
                      <option value='7:30'>7:30 am</option>
                      <option value='8:0'>8:00 am</option>
                      <option value='8:30'>8:30 am</option>
                      <option value='9:0'>9:00 am</option>
                      <option value='9:30'>9:30 am</option>
                      <option value='10:0'>10:00 am</option>
                      <option value='10:30'>10:30 am</option>
                      <option value='11:0'>11:00 am</option>
                      <option value='11:30'>11:30 am</option>
                      <option value='12:0'>12:00 pm</option>
                      <option value='12:30'>12:30 pm</option>
                      <option value='13:0'>1:00 pm</option>
                      <option value='13:30'>1:30 pm</option>
                      <option value='14:0'>2:00 pm</option>
                      <option value='14:30'>2:30 pm</option>
                      <option value='15:0'>3:00 pm</option>
                      <option value='15:30'>3:30 pm</option>
                      <option value='16:0'>4:00 pm</option>
                      <option value='16:30'>4:30 pm</option>
                      <option value='17:0'>5:00 pm</option>
                      <option value='17:30'>5:30 pm</option>
                      <option value='18:0'>6:00 pm</option>
                      <option value='18:30'>6:30 pm</option>
                      <option value='19:0'>7:00 pm</option>
                      <option value='19:30'>7:30 pm</option>
                      <option value='20:0'>8:00 pm</option>
                      <option value='20:30'>8:30 pm</option>
                      <option value='21:0'>9:00 pm</option>
                      <option value='21:30'>9:30 pm</option>
                      <option value='22:0'>10:00 pm</option>
                      <option value='22:30'>10:30 pm</option>
                      <option value='23:0'>11:00 pm</option>
                      <option value='23:30'>11:30 pm</option>
                    </select>
                  </div>
                </div>
                <div class='m-2'>
                  <button class="btn btn-secondary" class:disabled={alertInfo.voice_message.length < 2} disabled={alertInfo.voice_message.length < 2}  on:click|preventDefault={showTestAlertModal}>Test Voice Alert</button>
                </div>
              </div>
            </div>
          {/if}
          {#if smsChecked}
            <div class="tab-pane fade" class:active="{tabSelected === 'sms'}" class:show="{tabSelected === 'sms'}" id="profile" role="tabpanel" aria-labelledby="sms-tab">
              <div class='row'>
                <div class='col-md-12'>
                  <div class="form-group">
                    <label for="input-email-body" class='required-field'>Text Message</label>
                    <textarea 
                      bind:value={alertInfo.sms_body}
                      use:validate={alertInfo.sms_body}
                      class="form-control" 
                      class:border-danger={!$alertForm.sms_body.valid && $alertForm.sms_body.dirty}
                      id="input-email-body" 
                      placeholder="Text Message"
                      rows="4"></textarea>
          
                    {#if $alertForm.sms_body.errors.includes('required') && $alertForm.sms_body.dirty}
                      <p class='text-danger text-small'>Text message is required</p>
                    {/if}
                  </div>
                </div>
              </div>
            </div>
          {/if}
          {#if emailChecked}
            <div class="tab-pane fade" class:active="{tabSelected === 'email'}" class:show="{tabSelected === 'email'}" id="home" role="tabpanel" aria-labelledby="email-tab">
                <div class='row'>
                  <div class='col-md-12'>
                    <div class="form-group">
                      <label for="input-email-subject" class='required-field'>Email Subject</label>
                      <input 
                        type="text" 
                        bind:value={alertInfo.email_subject} 
                        use:validate={alertInfo.email_subject}
                        class="form-control" 
                        class:border-danger={!$alertForm.email_subject.valid && $alertForm.email_subject.dirty}
                        id="input-email-subject" 
                        placeholder="Email Subject">
                      {#if $alertForm.email_subject.errors.includes('required') && $alertForm.email_subject.dirty}
                        <p class='text-danger text-small'>Email subject is required</p>
                      {/if}
                    </div>
                  </div>
                </div>
                <div class='row'>
                  <div class='col-md-12'>
                    <div class="form-group">
                      <label for="input-email-body" class='required-field'>Email body</label>
                      <textarea 
                        bind:value={alertInfo.email_body}
                        use:validate={alertInfo.email_body}
                        class="form-control" 
                        class:border-danger={!$alertForm.email_body.valid && $alertForm.email_body.dirty}
                        id="input-email-body" 
                        placeholder="Email Body"
                        rows="4"></textarea>
          
                      {#if $alertForm.email_body.errors.includes('required') && $alertForm.email_body.dirty}
                        <p class='text-danger text-small'>Email body is required</p>
                      {/if}
                    </div>
                  </div>
                </div>
                <!-- <div class='row ml-10'>
                  <input 
                    type="file" 
                    bind:files
                    on:change={uploadFiles}
                  >
                </div> -->

                <div id="upload_button" class='row ml-10'>
                  <label>
                    <input type="file"
                    bind:files
                    on:change={uploadFiles} >
                    <span class="btn btn-secondary btn-sm">Add Attachment</span>
                  </label>
                </div>
                <!-- {#each files as file}
                  <span>{file.name}</span>
                {/each} -->
            </div>
          {/if}
        </div>
        <div class='m-2'>
          <button class="btn btn-primary mr-2" class:disabled={!isFormValid} disabled={!isFormValid}  on:click|preventDefault={send}>Send Alert</button>
        </div>
      </div>
    </div>
  </div>
</div>
<TestAlertModal on:sendTestVoiceAlert={(event) => sendTestVoiceAlert(event.detail)}></TestAlertModal>

<Modal isOpen={isModalOpen} {hideAlertModal}>
  <ModalHeader {hideAlertModal}>{alertModalHeader}</ModalHeader>
  <ModalBody>
    {alertModalBody}
  </ModalBody>
  <ModalFooter>
    <Button color="secondary" on:click={hideAlertModal}>
      Close
    </Button>
  </ModalFooter>
</Modal>

<style>
  .required-field::after {
    content: "*";
    color: red;
  }

  .no-text-transform {
    text-transform: none;
  }

  .tab-pane {
    margin: 10px;
  }

  .border-light {
    border: 1px solid #f3f3f3;
  }

  .ml-10 {
    margin-left: 5px;
  }

  #upload_button {
    display: inline-block;
  }
  #upload_button input[type=file] {
    display:none;
  }
</style>
